// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "popup_position-CHcYp";
var _3 = "popup_wrapper-3GkKA";
export { _1 as "__esModule", _2 as "popup_position", _3 as "popup_wrapper" }
export default { "__esModule": _1, "popup_position": _2, "popup_wrapper": _3 }
